<template>
<textarea class = "small"
          v-model='myTextarea' name="" cols="10" rows="6">
</textarea>
</template>

<script>
export default {
  props: ['jsonString'],
  name: 'JsonData',

  data () {
    return {
    }
  },
  computed: {
    myTextarea: function () {
      return JSON.stringify(this.jsonString, undefined, 2)
    }
  }

}
</script>

<style scoped>
body {
  padding: 3rem;
  font-size: 16px;
}

textarea {
  width: 100%;
  min-height: 10rem;
  font-family: "Lucida Console", Monaco, monospace;
  font-size: 0.7rem;
  line-height: 1.2;
}
</style>
